import React, { useId } from "react";

export default function TextInput({
    label,
    value,
    onChange,
    placeholder = "",
    type = "text",
    error = "",
    required = false,
    disabled = false,
    maxLength,
    onKeyDown,
    inputMode,
    autoFocus = false,
    id,
    name,
    autoComplete,
    dir,
}) {
    const generatedId = useId();
    const inputId = id || generatedId;
    const errorId = `${inputId}-error`;

    return (
        <div>

            {label && (
                <label htmlFor={inputId} className="mb-2 block text-sm font-medium text-gray-700">
                    {label}
                    {required && (
                        <span className="text-red-500 mr-1">*</span>
                    )}
                </label>
            )}

            <input
                id={inputId}
                name={name}
                type={type}
                value={value}
                onChange={onChange}
                placeholder={placeholder}
                disabled={disabled}
                maxLength={maxLength}
                required={required}
                onKeyDown={onKeyDown}
                inputMode={inputMode}
                autoFocus={autoFocus}
                autoComplete={autoComplete}
                dir={dir}
                aria-invalid={Boolean(error)}
                aria-describedby={error ? errorId : undefined}
                className={`
                    w-full
                    rounded-2xl
                    border
                    px-4
                    py-3.5
                    outline-none
                    transition-all duration-200

                    ${error
                        ? "border-red-400 focus:border-red-500 focus:ring-4 focus:ring-red-500/10"
                        : "border-gray-200 hover:border-gray-300 focus:border-primary focus:ring-4 focus:ring-primary/10"}

                    ${disabled
                        ? "bg-gray-100"
                        : "bg-white"}
                `}
            />

            {error && (
                <p id={errorId} role="alert" className="mt-2 text-xs leading-5 text-red-600">
                    {error}
                </p>
            )}

        </div>
    );

}
